import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import styles from './DropDownMenu.module.css';
import classNames from 'classnames';
import { IMenuItem } from 'src/lib/types/Settings';


//#region [Props]
type DropDownMenuProps = {
	menuItems?: IMenuItem[];
	isVisible: boolean;
};
//#endregion

//#region [Component]
export default function DropDownMenu({ menuItems, isVisible }: DropDownMenuProps) {
	if ((menuItems?.length ?? 0) === 0) {
		return null;
	}
	return <div className={classNames(styles.SDropDownWrapper, { 'visible': isVisible })}>
		<nav className={styles.SMenuItems}>
			{menuItems?.map(mi => {
				let isEaster = false;
				if (mi.text.toLocaleLowerCase().includes("påske")) isEaster = true;
				return <FilmwebLink key={mi._key} to={mi.url} className={classNames(styles.SMenuItem, { 'easter': isEaster })}>{mi.text}</FilmwebLink>
			})}
		</nav>
	</div>;
}
//#endregion

